<template>
  <div
    v-if="priceInfo.primary"
    class="slider__car--block"
    :class="colorClasses"
  >
    <p class="slider__car--font">
      {{ $t("offerForYou") }}
    </p>
    <div class="slider__car--description">
      <p class="slider__car--price">
        {{ priceInfo.primary.formatter(priceInfo.primary.price) }} zł
        <span class="slider__car--font">{{ priceInfo.category_id != 2? 'brutto' : 'netto' }}</span>
      </p>
    </div>
  </div>

  <div
    v-if="priceInfo.secondary"
    class="slider__car--block"
  >
    <p class="slider__car--font">
      {{ priceInfo.secondary.label }}
    </p>
    <div class="slider__car--description">
      <p class="slider__car--price">
        {{ priceInfo.secondary.formatter(priceInfo.secondary.price) }} zł
        <span class="slider__car--font">{{ priceInfo.category_id != 2? 'brutto' : 'netto' }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { useStore } from "../../store";
import { formatPrice } from "../../plugins/helpers";

export default {
  computed: {
    mainOffer() {
      const offer = useStore().mainOffer;
      return offer && offer.length > 0 ? offer[0] : null;
    },
    returnColor() {
      return useStore().getColor;
    },
    isUsedCar() {
      return this.mainOffer?.typeId === 2;
    },
    colorClasses() {
      return {
        'slider__car--block--blue': this.returnColor === '',
        'slider__car--block--bordo': this.returnColor === '#801C62',
        'slider__car--block--red': this.returnColor === '#c9012c',
      };
    },
    priceInfo() {
      const offer = this.mainOffer;
      let primary = null;
      let secondary = null;

      if (offer?.forYouPrice) {
        primary = {
          price: offer.forYouPrice,
          formatter: (p) => formatPrice(p, false),
        };
        if (offer.catalogPrice && offer.catalogPrice > offer.forYouPrice) {
          secondary = {
            price: offer.catalogPrice,
            category_id: offer.category_id,
            label: this.isUsedCar ? this.$t("offerPrice") : this.$t("catalogPrice"),
            formatter: (p) => formatPrice(p, false),
          };
        }
      }

      return { primary, secondary };
    },
  },
  methods: {
    formatPrice,
  },
};
</script>